/**
 * App Layout Component
 * Provides consistent layout structure for all authenticated pages
 * - Includes Topbar navigation
 * - Wraps page content
 * - Used for dashboards, journey pages, onboarding, provider directory, etc.
 */

import { Outlet } from 'react-router-dom';
import { Topbar } from '@/features/navigation/components/Topbar';
import { WorkspaceBanner } from '@/features/workspace-sub-delegation';

export const AppLayout = () => {
  return (
    // --app-topbar-h: height sticky page elements must clear. The Topbar only
    // exists below lg; at lg+ navigation is the fixed 240px sidebar (lg:pl-60).
    <div className="min-h-screen bg-background [--app-topbar-h:4rem] lg:pl-60 lg:[--app-topbar-h:0px]">
      {/* Feature 075: visible only for SUB_DELEGATE users */}
      <WorkspaceBanner />
      <Topbar />
      <main>
        <Outlet />
      </main>
    </div>
  );
};

